import { FunctionComponent, useCallback, useEffect, useState } from "react";
import "./Footer.scss";
import { useNavigate } from "react-router-dom";
import images from "../../assets/images";
import { useAppDispatch } from "../../redux/app/hooks";
import { logout } from "../../redux/slices/authSlice";
import { useQuery } from "@apollo/client";
import { GET_ALL_SOCIAL_MEDIA_LINKS } from "./api/footer";
import { GET_VERSION } from "../../pages/Help/api/Help";
import { VersionResponse } from "../../pages/Help/Help";
import moment from "moment";
import { isPlatform } from "@ionic/react";
import { getAppVersion } from "../../utils/helper";
import { trackButtonClick } from "../../firebase/analyticsHelper";
import { ButtonClickEvents } from "../../firebase/constants/events";
import { FETCH_POLICY } from "../../utils/constants";
interface MediaNode {
  mId: string;
  mediaLink: string;
  mediaName: string;
  createdAt: string;
  deletedAt: string | null;
  updatedAt: string;
}

// Define the structure for the allMedia object
interface AllMedia {
  nodes: MediaNode[];
}

// Define the structure for the entire response object
interface MediaResponse {
  allMedia: AllMedia;
}


const Footer: FunctionComponent = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const {Facebook,instagram,linkedin,xIcon,youtubeIcon,tiktokIcon} = images;

  const [appVersion, setAppVersion] = useState<string | null>(null);

  const currentYear = moment().format("YYYY");

  const {
    data : mediaLinkData
  } = useQuery<MediaResponse>(GET_ALL_SOCIAL_MEDIA_LINKS,{
    fetchPolicy: FETCH_POLICY,
    notifyOnNetworkStatusChange: true,
  });

  const {
    data : version,
  } = useQuery<VersionResponse>(GET_VERSION,{
    variables: { platformtype: 'EXE' },
    fetchPolicy: FETCH_POLICY,
    notifyOnNetworkStatusChange: true,
  });
  const onFacebookIconClick = useCallback(() => {
    trackButtonClick(ButtonClickEvents?.FACEBOOK_ICON_CLICK, {
        description : "User clicked the facebook icon",
    });

    const facebookMedia = mediaLinkData?.allMedia.nodes.find(
      (mediaNode) => mediaNode.mediaName === "facebook"
    );
    
    if (facebookMedia) {
      window.open(facebookMedia.mediaLink);
    }  }, [mediaLinkData]);

  const onSubtractIconClick = useCallback(() => {
    trackButtonClick(ButtonClickEvents?.INSTAGRAM_ICON_CLICK, {
        description : "User clicked the instagram icon",
    });

    const instagramMedia = mediaLinkData?.allMedia.nodes.find(
      (mediaNode) => mediaNode.mediaName === "instagram"
    );
    
    if (instagramMedia) {
      window.open(instagramMedia.mediaLink);
    }
  }, [mediaLinkData]);

  const onIcLinkedinClick = useCallback(() => {
    trackButtonClick(ButtonClickEvents?.lINKEDIN_ICON_CLICK, {
        description : "User clicked the linkedin icon",
    });

    const linkedInMedia = mediaLinkData?.allMedia.nodes.find(
      (mediaNode) => mediaNode.mediaName === "linkedin"
    );
    
    if (linkedInMedia) {
      window.open(linkedInMedia.mediaLink);
    }
  }, [mediaLinkData]);

  const onIcTwitterClick = useCallback(() => {
    trackButtonClick(ButtonClickEvents?.TWITTER_ICON_CLICK, {
        description : "User clicked the twitter icon",
    });

    const instagramMedia = mediaLinkData?.allMedia.nodes.find(
      (mediaNode) => mediaNode.mediaName === "twitter"
    );
    
    if (instagramMedia) {
      window.open(instagramMedia.mediaLink);
    }
  }, [mediaLinkData]);

  const onIcYoutubeClick = useCallback(() => {
    trackButtonClick(ButtonClickEvents?.YOUTUBE_ICON_CLICK, {
        description : "User clicked the youtube icon",
    });

    const youtubeMedia = mediaLinkData?.allMedia.nodes.find(
      (mediaNode) => mediaNode.mediaName === "youtube"
    );
    
    if (youtubeMedia) {
      window.open(youtubeMedia.mediaLink);
    }
  }, [mediaLinkData]);

  const onIcTictokClick = useCallback(() => {
    trackButtonClick(ButtonClickEvents?.TIKTOK_ICON_CLICK, {
        description : "User clicked the tiktok icon",
    });

    const tiktokMedia = mediaLinkData?.allMedia.nodes.find(
      (mediaNode) => mediaNode.mediaName === "tiktok"
    );
    
    if (tiktokMedia) {
      window.open(tiktokMedia.mediaLink);
    }
  }, [mediaLinkData]);

  const onFaqClick = useCallback(() => {
    trackButtonClick(ButtonClickEvents?.FAQ_TEXT_CLICK, {
        description : "User clicked the FAQ label",
    });
    navigate('/faq');
    dispatch(logout());
  }, []);

  const onLegalClick = useCallback(() => {
    trackButtonClick(ButtonClickEvents?.LEGAL_TEXT_CLICK, {
        description : "User clicked the Legal label",
    });
    navigate('/legal');
    dispatch(logout());
  }, []);

  const onSupportClick = useCallback(() => {
    trackButtonClick(ButtonClickEvents?.SUPPORT_TEXT_CLICK, {
        description : "User clicked the Support label",
    });
    navigate('/support');
    dispatch(logout());
  }, []);

  const fetchAppVersion = async () => {
    try {
      const version = await getAppVersion();
      setAppVersion(version);
    } catch (error) {
      console.error("Failed to fetch app version:", error);
    }
  };

  useEffect(() => {
    fetchAppVersion();
  }, []);

  return (
    <div className="sectionFooter">
      <div className="container">
        <div className="ftrMenu">
          <div className="faq" onClick={onFaqClick}>FAQ</div>
          <div className="faq" onClick={onLegalClick}>Legal</div>
          <div className="faq" onClick={onSupportClick}>Support</div>
        </div>
        <div className="versionCtn">
          <span className="katon">@{currentYear} Katon</span>
          <span className="katon">Version: { isPlatform('android') ? appVersion : version?.allVersions?.nodes[0].appVersion}</span>
        </div>
        <div className="ftrIcons">
          <div className="icFb">
            <img
              className="facebookIcon"
              alt="facebookIcon"
              src={Facebook}
              onClick={onFacebookIconClick}
            />
          </div>
          <div className="icFb">
            <img
              className="subtractIcon"
              alt="instagramIcon"
              src={instagram}
              onClick={onSubtractIconClick}
            />
          </div>
          <div className="icLinkedin" onClick={onIcLinkedinClick}>
            <img className="layer2Icon" alt="linekedInIcon" src={linkedin} />
          </div>
          <div className="icTwitter" onClick={onIcTwitterClick}>
            <img className="xIcon" alt="twitterIcon" src={xIcon} />
          </div>
          <div className="icTwitter" onClick={onIcYoutubeClick}>
            <img className="subtractIcon1" alt="youtubeIcon" src={youtubeIcon} />
          </div>
          <div className="icTwitter" onClick={onIcTictokClick}>
            <img className="vectorIcon" alt="tiktokIcon" src={tiktokIcon} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
